(() => {
  'use strict';
  const navs = [...document.querySelectorAll('[data-retail-nav]')];
  const desktop = matchMedia('(min-width: 1000px)');
  document.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => navs.forEach(nav => { nav.open = false; })));
  navs.forEach(nav => {
    const trigger = nav.querySelector('summary');
    let timer;
    let openedOnEnter = false;
    const setOpen = open => {
      if (open) navs.forEach(other => { if (other !== nav) other.open = false; });
      nav.open = open;
      trigger.setAttribute('aria-expanded', String(open));
    };
    nav.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(nav.open)));
    nav.addEventListener('pointerenter', event => { clearTimeout(timer); if (desktop.matches && event.pointerType === 'mouse' && !nav.open) { setOpen(true); openedOnEnter = true; } });
    trigger.addEventListener('click', event => { if (openedOnEnter) { event.preventDefault(); openedOnEnter = false; } });
    nav.addEventListener('pointerleave', () => { openedOnEnter = false; timer = setTimeout(() => { if (!nav.matches(':focus-within')) setOpen(false); }, 180); });
    nav.addEventListener('focusout', () => { setTimeout(() => { if (!nav.contains(document.activeElement)) setOpen(false); }, 0); });
    trigger.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { event.preventDefault(); setOpen(true); nav.querySelector('.retail-mega a')?.focus(); } });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && nav.open) { event.preventDefault(); setOpen(false); trigger.focus(); } });
    document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) setOpen(false); });
    desktop.addEventListener('change', () => setOpen(false));
  });
  document.querySelectorAll('[data-card-view]').forEach(button => {
    button.addEventListener('click', () => {
      const card = button.closest('[data-apparel-card]');
      card.classList.toggle('retail-show-back', button.dataset.cardView === 'back');
      card.querySelectorAll('[data-card-view]').forEach(view => view.setAttribute('aria-pressed', String(view === button)));
    });
  });
  document.querySelector('[data-retail-filter-toggle]')?.addEventListener('click', event => {
    const layout = document.querySelector('.collection-layout');
    const expanded = event.currentTarget.getAttribute('aria-expanded') !== 'true';
    event.currentTarget.setAttribute('aria-expanded', String(expanded));
    layout?.classList.toggle('retail-filters-open', expanded);
    if (expanded) layout?.querySelector('summary')?.focus();
  });
  document.addEventListener('keydown', event => {
    const toggle = document.querySelector('[data-retail-filter-toggle]');
    if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') {
      document.querySelector('.collection-layout')?.classList.remove('retail-filters-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
  document.addEventListener('pointerdown', event => {
    const toggle = document.querySelector('[data-retail-filter-toggle]');
    if (!toggle || toggle.contains(event.target) || event.target.closest('.collection-sidebar')) return;
    document.querySelector('.collection-layout')?.classList.remove('retail-filters-open');
    toggle.setAttribute('aria-expanded', 'false');
  });
  document.querySelectorAll('[data-retail-density]').forEach(button => button.addEventListener('click', () => {
    document.querySelector('.product-grid')?.setAttribute('data-density', button.dataset.retailDensity);
    document.querySelectorAll('[data-retail-density]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));
})();
